import axios from 'axios'
import { URL_API } from './Configuracion/configuracion'
import { storageService } from './Services/storage_service';
import { cerrarSesion } from './Services/functions_service';

class Api {
    static instance = null

    static getToken() {
        return storageService.getItem('refreshToken') ??
            storageService.getItem('user')?.token ??
            JSON.parse(sessionStorage.getItem('user') || '{}')?.token;
    }

    constructor(headers = {}) {
        this.base = axios.create({
            baseURL: URL_API,
            headers: {
                'Content-Type': 'application/json',
                // '-Security-Policy': 'upgrade-insecure-requests',
                // authorization: `Bearer ${token}`,
                ...headers,
            },
            timeout: 2700000,
            withCredentials: true,
            exposedHeaders: ['set-cookie'],
        })
        this.requestCount = 0
    }

    static getInstance() {
        // if (!Api.instance) {
        const token = Api.getToken();

        Api.instance = new Api(
            token ? { authorization: `Bearer ${token}` } : {}
        )
        // }
        return Api.instance
    }

    static setInstance(dispatch, logout, token) {
        Api.instance = new Api(dispatch, logout, {
            authorization: `Bearer ${token}`,
        })
    }

    executeQuery = async (endpoint, variables) => {
        this.requestCount++
        this.updateLoadingStatus()

        try {
            const response = await this.base.post(endpoint, variables)
            // const refreshTokenCookie = cookies.get('refreshToken') ?? storageService.getItem('user')?.token;
            // if (refreshTokenCookie) {
            //     this.updateAuthorizationHeader(refreshTokenCookie)
            // }

            return response.data
        } catch (error) {
            let titulo = '',
                mensaje = ''
            if (error.response) {
                titulo = error.response?.data?.Title
                mensaje = error.response?.data?.Message
            } else {
                titulo = 'Error'
                mensaje = error.message
            }
            if (error.response?.status === 401) {
                cerrarSesion({ titulo: titulo, mensaje: mensaje });
            }
            throw error
        } finally {
            this.requestCount--
            this.updateLoadingStatus()
        }
    }

    executeGetQuery = async (endpoint) => {
        this.requestCount++
        this.updateLoadingStatus()

        try {
            const response = await this.base.get(endpoint)
            const refreshTokenCookie = Api.getToken();
            if (refreshTokenCookie) {
                this.updateAuthorizationHeader(refreshTokenCookie)
            }

            return response.data
        } catch (error) {
            let titulo = '',
                mensaje = ''
            if (error.response) {
                titulo = error.response?.data?.Title
                mensaje = error.response?.data?.Message
            } else {
                titulo = 'Error'
                mensaje = error.message
            }
            if (error.response?.status === 401) {
                cerrarSesion({ titulo: titulo, mensaje: mensaje });
            }
            throw error
        } finally {
            this.requestCount--
            this.updateLoadingStatus()
        }
    }

    executeUpdateQuery = async (endpoint, variables) => {
        this.requestCount++
        this.updateLoadingStatus()

        try {
            const response = await this.base.patch(endpoint, variables)
            const refreshTokenCookie = Api.getToken();
            if (refreshTokenCookie) {
                this.updateAuthorizationHeader(refreshTokenCookie)
            }
            return response.data
        } catch (error) {
            console.log(error);
            let titulo = '',
                mensaje = ''
            if (error.response) {
                titulo = error.response?.data?.Title
                mensaje = error.response?.data?.Message
            } else {
                titulo = 'Error'
                mensaje = error.message
            }
            if (error.response?.status === 401) {
                cerrarSesion({ titulo: titulo, mensaje: mensaje });
            }
            throw error
        } finally {
            this.requestCount--
            this.updateLoadingStatus()
        }
    }

    executeDeleteQuery = async (endpoint, variables) => {
        this.requestCount++
        this.updateLoadingStatus()

        try {
            const response = await this.base.delete(endpoint, variables)
            const refreshTokenCookie = Api.getToken();
            if (refreshTokenCookie) {
                this.updateAuthorizationHeader(refreshTokenCookie)
            }
            return response.data
        } catch (error) {
            let titulo = '',
                mensaje = ''
            if (error.response) {
                titulo = error.response?.data?.Title
                mensaje = error.response?.data?.Message
            } else {
                titulo = 'Error'
                mensaje = error.message
            }
            if (error.response?.status === 401) {
                cerrarSesion({ titulo: titulo, mensaje: mensaje });
            }
            throw error
        } finally {
            this.requestCount--
            this.updateLoadingStatus()
        }
    }

    // dentro de class Api
    executeMultipart = async (endpoint, formData) => {
        this.requestCount++;
        this.updateLoadingStatus();
        try {
            // Clave: headers sin 'application/json' y sin fijar multipart a mano,
            // y transformRequest que no toque el FormData
            const response = await this.base.post(endpoint, formData, {
                headers: { 'Content-Type': undefined }, // override del default
                transformRequest: v => v,
            });
            return response.data;
        } catch (error) {
            let titulo = '', mensaje = '';
            if (error.response) {
                titulo = error.response?.data?.Title;
                mensaje = error.response?.data?.Message;
            } else {
                titulo = 'Error';
                mensaje = error.message;
            }
            if (error.response?.status === 401) {
                cerrarSesion({ titulo, mensaje });
            }
            throw error;
        } finally {
            this.requestCount--;
            this.updateLoadingStatus();
        }
    }

    updateLoadingStatus() {
        if (typeof this.dispatch === 'function') {
            // this.requestCount === 0
            //     ? this.dispatch(setComplete())
            //     : this.dispatch(setLoading())
        }
    }

    async updateAuthorizationHeader(newAccessToken) {
        // console.log(`update ${newAccessToken}`)
        Api.setInstance(
            this.dispatch,
            this.logout,
            newAccessToken.replace('Bearer ', '')
        )
    }
}

export default Api